module.exports = fox => {
    var Constructor = function (options) {
        this._objClass = 'LocalStorageObjectService';
        this.__constructor.call(this, options || {});

        return this;
    };

    var LocalStorageObjectService = fox.extend({
        __constructor: function (options) {
            this._lsLabel = options.lsLabel || ['label', fox.uniqid()].join('_');
            this._cleanCheckInterval = fox.isUndefined(options.cleanCheckInterval) &&
                1000 * 60 * 60 * 24 * 2 ||
                options.cleanCheckInterval;

            this.ls = fox.utils.localStorage;

            if (this._cleanCheckInterval)
                this.cleanOldLSData();
        },

        cleanOldLSData: function () {
            var data, now;

            data = this.getLSData();
            now = new Date().getTime();

            if (fox.isObject(data)) {
                fox.each(data, function (val, key) {
                    if (val.hasOwnProperty('timestamp') &&
                        (now - val.timestamp) > this._cleanCheckInterval) {
                        this.removeItem(key);
                    }
                }, this);
            }
        },

        getLSData: function () {
            var data;

            try {
                data = JSON.parse(this.ls('getItem', this._lsLabel));
            } catch (e) {
                console.log(e);
            }

            return data;
        },

        setLSData: function (data) {
            return this.ls('setItem', this._lsLabel, JSON.stringify(data || {}));
        },

        setItem: function (id, value) {
            var data, time = new Date().getTime();

            data = this.getLSData();

            if (fox.isString(value)) {
                value = {
                    value: value,
                    timestamp: time
                };
            }

            if (fox.isObject(value)) {
                value.timestamp = time;
            }

            if (fox.isEmpty(data) || !fox.isObject(data)) data = {};

            data[id] = value;

            this.setLSData(data);
        },

        getItem: function (id) {
            var data = (this.getLSData() || {})[id];

            if (fox.isObject(data) && 'timestamp' in data)
                delete data.timestamp;

            return data;
        },

        removeItem: function (id) {
            var data;

            data = this.getLSData();

            fox.each(data, function (val, key) {
                if (key === id) {
                    delete data[key];
                }
            });

            this.setLSData(data);
        }

    }, fox.BaseObject, Constructor, 'LocalStorageObjectService');

    fox.registerService('LocalStorageObjectService', LocalStorageObjectService);
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/common-stuffs/localStorageService.es.js